var map = {
	"./0.5.png": 1292,
	"./0.png": 345,
	"./1-2.png": 346,
	"./1.png": 347,
	"./10.png": 356,
	"./11.png": 357,
	"./12.png": 358,
	"./13.png": 359,
	"./14.png": 360,
	"./15.png": 361,
	"./16.png": 362,
	"./17.png": 363,
	"./18.png": 364,
	"./19.png": 365,
	"./2.png": 348,
	"./20.png": 366,
	"./3.png": 349,
	"./4.png": 350,
	"./5.png": 351,
	"./6.png": 352,
	"./7.png": 353,
	"./8.png": 354,
	"./9.png": 355,
	"./G1-2-red.png": 1293,
	"./G1-2.png": 1294,
	"./G1.png": 1295,
	"./G10.png": 1296,
	"./G2.png": 1297,
	"./G3.png": 1298,
	"./G4.png": 1299,
	"./G5.png": 1300,
	"./G6.png": 1301,
	"./G7.png": 1302,
	"./G8.png": 1303,
	"./G9.png": 1304,
	"./Lruler.png": 1305,
	"./Lsign.png": 1306,
	"./Nsign.png": 1307,
	"./Seen-Sign.png": 1308,
	"./alternate_rotate.png": 1309,
	"./annotations/big/eval/1.png": 1310,
	"./annotations/big/eval/2.png": 1311,
	"./annotations/big/eval/3.png": 1312,
	"./annotations/big/eval/4.png": 1313,
	"./annotations/big/eval/5.png": 1314,
	"./annotations/big/eval/6.png": 1315,
	"./annotations/big/eval/7.png": 1316,
	"./annotations/big/eval/comment.png": 1317,
	"./annotations/big/mod/1.png": 1318,
	"./annotations/big/mod/2.png": 1319,
	"./annotations/big/mod/3.png": 1320,
	"./annotations/big/mod/4.png": 1321,
	"./annotations/big/mod/5.png": 1322,
	"./annotations/big/mod/6.png": 1323,
	"./annotations/big/mod/7.png": 1324,
	"./annotations/big/mod/comment.png": 1325,
	"./annotations/blue.png": 1326,
	"./annotations/red.png": 1327,
	"./annotations/small/eval/1.png": 1328,
	"./annotations/small/eval/2.png": 1329,
	"./annotations/small/eval/3.png": 1330,
	"./annotations/small/eval/4.png": 1331,
	"./annotations/small/eval/5.png": 1332,
	"./annotations/small/eval/6.png": 1333,
	"./annotations/small/eval/7.png": 1334,
	"./annotations/small/mod/1.png": 1335,
	"./annotations/small/mod/2.png": 1336,
	"./annotations/small/mod/3.png": 1337,
	"./annotations/small/mod/4.png": 1338,
	"./annotations/small/mod/5.png": 1339,
	"./annotations/small/mod/6.png": 1340,
	"./annotations/small/mod/7.png": 1341,
	"./answer-paper.png": 1342,
	"./c1-2.png": 1343,
	"./c1.png": 1344,
	"./c10.png": 1345,
	"./c2.png": 1346,
	"./c3.png": 1347,
	"./c4.png": 1348,
	"./c5.png": 1349,
	"./c6.png": 1350,
	"./c7.png": 1351,
	"./c8.png": 1352,
	"./c9.png": 1353,
	"./cmt.png": 1354,
	"./comment.png": 1355,
	"./comment.svg": 1356,
	"./complete_timer.png": 1357,
	"./draft.png": 1358,
	"./drawing.png": 1359,
	"./drawing_mask.png": 1360,
	"./graph.png": 1361,
	"./graph_mask.png": 1362,
	"./left.svg": 1363,
	"./masked.png": 1364,
	"./message.png": 1365,
	"./mouse-1.png": 667,
	"./mouse.jpeg": 1366,
	"./new_offline.gif": 1367,
	"./nonset_timer.png": 1368,
	"./offline.gif": 1369,
	"./online.gif": 1370,
	"./paper.png": 1371,
	"./paper_side.png": 1372,
	"./paper_top.png": 1373,
	"./pred.png": 1374,
	"./protractor.png": 1375,
	"./que_ans.png": 1376,
	"./question.png": 668,
	"./reject.png": 1377,
	"./right.svg": 1378,
	"./rotate.png": 1379,
	"./ruler.png": 1380,
	"./tringale.png": 1381,
	"./truler.png": 1382,
	"./write.png": 344,
	"./wrong.png": 1383,
	"./x.png": 343,
	"./x2000.png": 1384,
	"./x_1.png": 1385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;